// extracted by mini-css-extract-plugin
export default {"cls1":"FeedFilters-cls1___87e6588cf36003799ee","cls2":"FeedFilters-cls2___b927f5f9c80b920c1ab FeedFilters-cls1___87e6588cf36003799ee"};